var _circle, _path, _path2, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPug(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_type_pug") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M25.514,12.846c-.052-.938.209-1.825-.209-2.554-1.043-1.825-3.649-2.867-8.863-2.867V7.372h0v.052c-5.735,0-8.185,1.043-9.227,2.867a5.6,5.6,0,0,0-.469,2.554,9.546,9.546,0,0,0-.261,2.45c.156,1.147.261,2.294.417,3.336.156.886,1.408,1.564,1.564,2.4.313,2.242,2.294,3.284,8.028,3.284v.261h-.1v-.261c5.213,0,7.4-1.043,7.716-3.284.1-.834,1.147-1.512,1.3-2.4.156-1.043.209-2.19.365-3.336A11.774,11.774,0,0,0,25.514,12.846Z",
    style: {
      fill: "#efcca3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.182,13.68a3.241,3.241,0,0,1,2.19,1.147c.73.626,1.929,1.043,2.45,1.616a4.715,4.715,0,0,1,1.408,1.981,8.9,8.9,0,0,1,.313,2.242c0,.261.156.209.573,0a9.02,9.02,0,0,0,2.19-1.877c-.156.886-1.251,1.668-1.355,2.5-.313,2.242-2.5,3.336-7.872,3.336h.313",
    style: {
      fill: "#ccac8d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.519,11.908c.209.678.886,3.024-.469,2.242a2.557,2.557,0,0,1,.938,1.564,1.831,1.831,0,0,0,1.3,1.408,3.479,3.479,0,0,0,2.554-.626,2.956,2.956,0,0,0,.678-3.284,2.43,2.43,0,0,0-2.137-1.616C21.4,11.334,19.31,11.126,19.519,11.908Z",
    style: {
      fill: "#ccac8d"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.178,
    cy: 14.41,
    r: 1.929
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 21.656,
    cy: 13.524,
    r: 0.521,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.206,14.306a17.68,17.68,0,0,1,2.711,2.346c.938,1.2.938,1.408.938,1.408l-.678.313a7.1,7.1,0,0,0-2.137-2.5c-1.2-.678-1.355-1.251-1.355-1.251Z",
    style: {
      fill: "#efcca3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.235,13.68a3.605,3.605,0,0,0-2.346,1.147c-.73.626-2.033,1.043-2.5,1.616a4.806,4.806,0,0,0-1.46,1.981,8.9,8.9,0,0,0-.313,2.242c0,.261.052.313-.626,0A7.972,7.972,0,0,1,6.8,18.789c.156.886,1.251,1.668,1.355,2.5.313,2.19,2.5,3.284,7.872,3.284h.365",
    style: {
      fill: "#ccac8d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.239,17.277a6.552,6.552,0,0,0-5.109-2.607h0a6.638,6.638,0,0,0-5.109,2.607,3.861,3.861,0,0,0-1.043,3.18c0,4.64,1.616,3.232,2.711,3.806a7.466,7.466,0,0,0,3.389.313h0a7.4,7.4,0,0,0,3.389-.313c1.095-.573,2.711.834,2.711-3.806A3.386,3.386,0,0,0,21.239,17.277Z",
    style: {
      fill: "#56332b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.026,15.974a9.549,9.549,0,0,1-.469,2.554l.573-.156Z",
    style: {
      fill: "#442823"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.182,15.974a9.549,9.549,0,0,0,.469,2.554l-.573-.156Z",
    style: {
      fill: "#442823"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.358,15.453c-.209-.521.573-1.355,1.825-1.355s2.033.834,1.825,1.355-1.043.678-1.825.678C15.348,16.13,14.566,15.974,14.358,15.453Z",
    style: {
      fill: "#56332b"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.182,15.974c0-.1.73-.1,1.147-.365,0,0-.834.261-.991.156a.656.656,0,0,1-.209-.365.656.656,0,0,1-.209.365c-.156.1-1.095-.156-1.095-.156a8.058,8.058,0,0,1,1.2.365v.417a10.492,10.492,0,0,0,.1,2.033c.156.209.1-1.46.1-2.033A1.3,1.3,0,0,1,16.182,15.974Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.182,18.945a3.35,3.35,0,0,1,1.616.678,3.121,3.121,0,0,0-1.616-1.095,3.036,3.036,0,0,0-1.825,1.2A3.312,3.312,0,0,1,16.182,18.945Z",
    style: {
      fill: "#7f4a41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.078,22.8a8.9,8.9,0,0,1-2.4-.469c-.156-.052-.313.052-.469,0a6.172,6.172,0,0,1-3.18-2.137v.209c0,4.64,1.616,3.232,2.711,3.806a7.466,7.466,0,0,0,3.389.313h0a7.4,7.4,0,0,0,3.389-.313c1.095-.573,2.711.834,2.711-3.806v-.469A5.914,5.914,0,0,1,19,22.282c-.156.052-.417-.052-.573-.052A7.045,7.045,0,0,1,16.078,22.8Z",
    style: {
      fill: "#442823"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.941,20.3s-.573,1.668-.156,2.4l-.521-.209A15.433,15.433,0,0,1,13.941,20.3Z",
    style: {
      fill: "#442823"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.32,20.3s.573,1.668.156,2.4L19,22.491A10.629,10.629,0,0,0,18.32,20.3Z",
    style: {
      fill: "#442823"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.585,11.908c-.209.678-.886,3.024.469,2.242a2.557,2.557,0,0,0-.938,1.564,1.831,1.831,0,0,1-1.3,1.408A3.479,3.479,0,0,1,8.258,16.5a2.956,2.956,0,0,1-.678-3.284,2.43,2.43,0,0,1,2.137-1.616C10.709,11.334,12.794,11.126,12.585,11.908Z",
    style: {
      fill: "#ccac8d"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.13,18.528a3.393,3.393,0,0,1,2.45,2.867v-.1a3.051,3.051,0,0,0-2.45-2.919,3,3,0,0,0-2.45,2.919v.1A3.463,3.463,0,0,1,16.13,18.528Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.546,
    cy: 15.138,
    rx: 0.156,
    ry: 0.313,
    transform: "translate(-3.256 4.611) rotate(-14.46)",
    style: {
      fill: "#331712"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.609,
    cy: 15.146,
    rx: 0.313,
    ry: 0.156,
    transform: "translate(-3.482 25.567) rotate(-72.765)",
    style: {
      fill: "#331712"
    }
  }), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.031,
    cy: 14.41,
    r: 1.929
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 10.552,
    cy: 13.524,
    r: 0.521,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7,14.41s-.521.209-.626.261a2.492,2.492,0,0,1-.626-.261H16.7Z",
    style: {
      fill: "#7f4a41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9,14.306a17.68,17.68,0,0,0-2.711,2.346c-.938,1.2-.938,1.408-.938,1.408l.678.313a7.1,7.1,0,0,1,2.137-2.5c1.2-.678,1.355-1.251,1.355-1.251Z",
    style: {
      fill: "#efcca3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.092,10.813a4.519,4.519,0,0,1-1.929,2.294A2.19,2.19,0,0,0,9.092,10.813Z",
    style: {
      fill: "#ccac8d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.908,10.813a4.519,4.519,0,0,0,1.929,2.294A2.19,2.19,0,0,1,22.908,10.813Z",
    style: {
      fill: "#ccac8d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.31,13.836a5.16,5.16,0,0,0-3.076-1.408h.156a3.852,3.852,0,0,0-3.024,1.408,4.832,4.832,0,0,1,3.024-1.043h0A5.785,5.785,0,0,1,19.31,13.836Z",
    style: {
      fill: "#ccac8d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.746,10.969a2.455,2.455,0,0,0-1.564-.938h.156a1.786,1.786,0,0,0-1.512.938,2.187,2.187,0,0,1,1.512-.678h0A1.894,1.894,0,0,1,17.746,10.969Z",
    style: {
      fill: "#ccac8d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.031,17.746a2.545,2.545,0,0,1-1.773.209H8.05a3.68,3.68,0,0,1-.886-1.512A2.27,2.27,0,0,0,10.031,17.746Z",
    style: {
      fill: "#ccac8d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.126,17.746a2.545,2.545,0,0,0,1.773.209H23.69a1.749,1.749,0,0,0,1.095-1.512A2.02,2.02,0,0,1,22.126,17.746Z",
    style: {
      fill: "#ccac8d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.23,10.709a4.75,4.75,0,0,1,2.242.1c.938.313.209,1.564.365,1.616a2.865,2.865,0,0,1,2.242-.73c1.773.1,1.981.886,2.242.73.261-.1-.261-2.19,2.45-1.72,0,0-2.763-.73-2.659,1.251a3.675,3.675,0,0,0-3.858-.1S14.827,9.927,11.23,10.709Z",
    style: {
      fill: "#ccac8d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5,8s-2.4,2.972-2.711,4.118c-.365,1.147-.626,5.943-.938,6.621L5.756,14.045l2.033-4.9Z",
    style: {
      fill: "#ccac8d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.656,8s2.4,2.972,2.711,4.118c.365,1.147.626,5.943.938,6.621L26.4,14.045l-2.033-4.9Z",
    style: {
      fill: "#ccac8d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5,8a11.617,11.617,0,0,1,3.284,4.588c.73,2.45.417,5.474.991,5.839.834.521,1.72-2.607,2.033-2.919.469-.521,2.085-1.877,2.19-2.137s-3.232-3.91-4.744-4.64C23.585,7.893,21.4,7.789,21.5,8Z",
    style: {
      fill: "#56332b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.69,9.3a15.379,15.379,0,0,1,2.972,8.654l1.2-2.45A16.564,16.564,0,0,0,23.69,9.3Z",
    style: {
      fill: "#442823"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5,8a11.617,11.617,0,0,0-3.284,4.588c-.73,2.45-.417,5.474-.991,5.839-.834.521-1.72-2.607-2.033-2.919-.469-.521-2.085-1.877-2.19-2.137s3.232-3.91,4.744-4.64C8.415,7.893,10.6,7.789,10.5,8Z",
    style: {
      fill: "#56332b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.31,9.3a15.379,15.379,0,0,0-2.972,8.654L4.14,15.5A16.564,16.564,0,0,1,8.31,9.3Z",
    style: {
      fill: "#442823"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.642,18.007a4.118,4.118,0,0,0,.573,1.564c.365.365.1-.313.1-.313s-.365-.209-.313-1.72S6.642,18.007,6.642,18.007Z",
    style: {
      fill: "#ccac8d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.41,18.007a4.118,4.118,0,0,1-.573,1.564c-.365.365-.1-.313-.1-.313s.365-.209.313-1.72C24.993,16.078,25.41,18.007,25.41,18.007Z",
    style: {
      fill: "#ccac8d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.889,
    cy: 17.121,
    r: 0.156,
    style: {
      fill: "#442823"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.846,
    cy: 18.216,
    r: 0.156,
    style: {
      fill: "#442823"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.533,
    cy: 17.121,
    r: 0.156,
    style: {
      fill: "#442823"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.164,
    cy: 17.121,
    r: 0.156,
    style: {
      fill: "#442823"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.154,
    cy: 18.216,
    r: 0.156,
    style: {
      fill: "#442823"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.467,
    cy: 17.121,
    r: 0.156,
    style: {
      fill: "#442823"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPug);
export default __webpack_public_path__ + "static/media/pug.a2ebd3e7bc5fb71a98a962c8067e961d.svg";
export { ForwardRef as ReactComponent };